<template src="./login.html"></template>

<script>
import { pwdForgot_mail } from "@/api/api.auth.js";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      e1: true,

      cred: {
        username: "",
        password: "",
        mail: "",
      },
      attesa: false,

      recuperaPwd: false,
      alertPwd: "",
      tipoAlert: "success",
      mailInvio: false,
      attesaMail: false,

      recuperaCred: false,
    };
  },

  methods: {
    async submit() {
      window.scrollTo(0, 0); // Scroll to top (serve sul mobile per vedere eventuali messaggi)

      // Reset messaggi
      this.$toast.close();

      // Validazione
      if (this.$refs.formLogin.validate() == false) {
        return;
      }

      // Attesa
      this.attesa = true;

      try {
        // Login
        await this.$store.dispatch("auth/login", this.cred);

        // Vado alla pagina riservata
        this.$router.push({ path: "/" });
      } catch (error) {
        this.$toast.alert(this.$functions.getErrorMsg(error));
      }

      this.attesa = false;
    },

    recupera() {
      this.recuperaCred = true;
    },

    async pwdDimenticata() {
      // Validazione
      if (this.$refs.resetPwd.validate() == false) {
        return;
      }

      this.attesaMail = true;
      this.alertPwd = "";

      try {
        let res = await pwdForgot_mail(this.cred);

        if (res.data == "OK") {
          this.mailInvio = true;
          this.alertPwd = "";

          this.tipoAlert = "success";
          this.alertPwd =
            "Abbiamo inviato un messaggio al tuo indirizzo e-mail con il link per la reimpostazione della password.";

          //this.resetCred();
        } else this.$toast.alert("Impossibile effettuare il reset della password.");
      } catch (error) {
        this.tipoAlert = "warning";
        this.alertPwd = this.$i2kFunctions.getErrorMsg(error);
      }

      this.attesaMail = false;
    },

    resetCred() {
      this.cred.username = "";
      this.cred.password = "";
      this.cred.mail = "";
      this.recuperaPwd = false;
      this.alertPwd = "";
      this.tipoAlert = "success";
      this.mailInvio = false;
      this.recuperaCred = false;

      this.$nextTick(() => this.$refs.formLogin.resetValidation());

      // NOTA: il focus sul campo username viene attivato solo la prima volta
      this.$nextTick(() => this.$refs.inputName.focus());
    },
  },
};
</script>
